<!-- Cabecera de botones -->
<form [formGroup]='formHeader' novalidate>
  <div class="card mb-2 wow detalle-cliente">
    <div class="card-body justify-content-between">
      <div class="row filtros-body">
        <div class="col" style="max-width: 200px;">
          <div class="md-form">
            <mdb-date-picker [inline]="true" name="fechaDesde" [placeholder]="'Desde'" required
              formControlName="fechaDesde"></mdb-date-picker>
            <div *ngIf="
                                  formHeader.get('fechaDesde').invalid &&
                                  (formHeader.get('fechaDesde').dirty ||
                                  formHeader.get('fechaDesde').touched)
                                  ">
              <mdb-error *ngIf="formHeader.get('fechaDesde').hasError('required')">
                Ingrese fecha desde
              </mdb-error>
            </div>
          </div>
        </div>
        <div class="col" style="max-width: 200px;">
          <div class="md-form">
            <mdb-date-picker [inline]="true" name="fechahasta" [placeholder]="'Hasta'" required
              formControlName="fechaHasta"></mdb-date-picker>
            <div *ngIf="
                                  formHeader.get('fechaHasta').invalid &&
                                  (formHeader.get('fechaHasta').dirty ||
                                  formHeader.get('fechaHasta').touched)
                              ">
              <mdb-error *ngIf="formHeader.get('fechaHasta').hasError('required')">
                Ingrese fecha hasta
              </mdb-error>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- FOOTER -->
    <div class="card-footer text-muted filtros-footer" style="border-top: 1px solid #dee2e6;">
      <div></div>
      <button mdbBtn type="button" color="secondary" size="sm" mdbWavesEffect (click)="buscar()">
        <mdb-icon fas icon="search"></mdb-icon>
        Buscar
      </button>
    </div>
  </div>
</form>